export const BodilyInjuryOptions = [
  { label: "1,00,000", value: "1,00,000" },
  { label: "2,00,000", value: "2,00,000" },
  { label: "3,00,000", value: "3,00,000" },
  { label: "4,00,000", value: "4,00,000" },
  { label: "5,00,000", value: "5,00,000" },
];

export const PropertyDamageOptions = [
  { label: "1,00,000", value: "1,00,000" },
  { label: "2,00,000", value: "2,00,000" },
  { label: "3,00,000", value: "3,00,000" },
  { label: "4,00,000", value: "4,00,000" },
  { label: "5,00,000", value: "5,00,000" },
];

export const AutopassengerpersonalAccidentOptions = [
  { label: "10,000", value: "10,000" },
  { label: "20,000", value: "20,000" },
  { label: "30,000", value: "30,000" },
  { label: "40,000", value: "40,000" },
  { label: "50,000", value: "50,000" },
];
